var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCatalog({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 1H6c-1.442 0-2.424.002-3.159.1-.706.096-1.033.263-1.255.486-.223.222-.39.55-.485 1.255C1.002 3.576 1 4.558 1 6v12c0 1.442.002 2.424.1 3.159.096.706.263 1.033.486 1.255.222.223.55.39 1.255.485C3.576 22.998 4.558 23 6 23h12c1.442 0 2.424-.002 3.159-.1.706-.096 1.033-.263 1.255-.486.223-.222.39-.55.485-1.255.099-.735.101-1.716.101-3.159V6c0-1.442-.002-2.424-.1-3.159-.096-.706-.263-1.033-.486-1.255-.222-.223-.55-.39-1.255-.485C20.424 1.002 19.443 1 18 1zM.879.879C0 1.757 0 3.172 0 6v12c0 2.828 0 4.243.879 5.121C1.757 24 3.172 24 6 24h12c2.828 0 4.243 0 5.121-.879C24 22.243 24 20.828 24 18V6c0-2.828 0-4.243-.879-5.121C22.243 0 20.828 0 18 0H6C3.172 0 1.757 0 .879.879z",
    fill: "#646D7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 6.5A.5.5 0 0114 6h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm0 2A.5.5 0 0114 8h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm-6-3a2 2 0 100 4 2 2 0 000-4zm-3 2a3 3 0 116 0 3 3 0 01-6 0zm9 8a.5.5 0 01.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm0 2a.5.5 0 01.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm-6-3a2 2 0 100 4 2 2 0 000-4zm-3 2a3 3 0 116 0 3 3 0 01-6 0z",
    fill: "#646D7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCatalog);
export default __webpack_public_path__ + "static/media/ic-catalog.47dfa724e5cb0d311b3c6bbc01798b9d.svg";
export { ForwardRef as ReactComponent };